






import { Component, Prop, Vue } from 'vue-property-decorator'
import * as battle from '@/services/battle';

@Component
export default class AttackResult extends Vue {
  @Prop({ type: Object, required: true })
  attackResult: any;

  get outcome(): string {
    const { attackResult } = this

    if (!attackResult) {
      return '';
    }

    switch (attackResult.outcome) {
      case battle.OutcomeType.MISS:
        return 'Your attack missed!'
      case battle.OutcomeType.HIT:
        return `You dealt ${attackResult.damage} damage!`;
      case battle.OutcomeType.CRITICAL:
        return `You crit for ${attackResult.damage} damage!`
    }
    return ''
  }
}
